import { ThemeOptions } from '@mui/material';

const breakpoints: ThemeOptions['breakpoints'] = {
  values: {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1440,
  },
};

export default breakpoints;
